import React from 'react';

import { IProps } from './types';

/**
 * Original viewBox="0 0 16 24"
 */
const MediumHotDrink: React.FC<IProps> = ({
  fill = Styles.color.white,
  stroke = Styles.color.black,
  ...rest
}) => (
  <svg viewBox="0 0 21 32" {...rest}>
    <title>Medium Hot drink</title>
    <g
      style={{
        transform: `scale(${1 / 14}, ${1 / 20}) scale(16, 24) translate(${(21 - 16) / 2}px, ${
          32 - 24 - 2
        }px)`,
      }}
    >
      <path
        d="M4,3.25h6A1.75,1.75,0,0,1,11.74,5v.08l-.58,12a1.74,1.74,0,0,1-1.75,1.67H4.59a1.74,1.74,0,0,1-1.75-1.67l-.58-12A1.76,1.76,0,0,1,3.93,3.25Z"
        style={{
          fill,
          stroke,
          strokeWidth: '1.5px',
          fillRule: 'evenodd',
        }}
      />
      <path
        d="M6,13,8.5,8.5"
        style={{
          fill: 'none',
          stroke,
          strokeWidth: '1.5px',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
        }}
      />
      <rect
        x="1.25"
        y="1.25"
        width="11.5"
        height="3.5"
        rx="1"
        style={{
          fill,
          stroke,
          strokeWidth: '1.5px',
        }}
      />
    </g>
  </svg>
);

export default MediumHotDrink;
